<template>
  <div class="wa-step wa-step--migration-prep">
    <h2 class="wa-step__heading">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.heading') }}
    </h2>
    <p class="wa-step__lead">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.lead') }}
    </p>
    <h3 class="wa-step__subheading">
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.procedureTitle') }}
    </h3>
    <ul class="wa-step__bullets">
      <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.bullet1') }}</li>
      <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.bullet2') }}</li>
      <li>{{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.bullet3') }}</li>
    </ul>
    <button
      type="button"
      class="wa-step__link-button"
      @click="$emit('want-new-number')"
    >
      {{ t('storeParameters.services.whatsappBusinessParameter.onboarding.paths.waApp.prep.wantNewNumber') }}
    </button>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';
export default defineComponent({
  name: 'WhatsappMigrationPrepStep',

  emits: ['want-new-number'],

  setup() {
    const { t } = useI18n();
    return { t };
  },
});
</script>
